import type { LocationDetail } from 'state/ducks/locations/models'

import type {
  FetchNearbySpacesParams,
  NearbySpacesFilterCondition,
} from 'features/space/types/nearbySpace'

type BuildNearbySpacesParamsInput = {
  locationDetail: LocationDetail
  isCity: boolean
  page: number
  pageSize: number
  locale: string
  filterCondition: NearbySpacesFilterCondition | null
}

export const buildNearbySpacesParams = ({
  locationDetail,
  isCity,
  page,
  pageSize,
  locale,
  filterCondition,
}: BuildNearbySpacesParamsInput): FetchNearbySpacesParams => {
  const base: FetchNearbySpacesParams = {
    latitude: locationDetail.latitude,
    longitude: locationDetail.longitude,
    page,
    page_size: pageSize,
    locale,
    ...(filterCondition ? { filter_condition: filterCondition } : {}),
  }

  if (isCity) {
    return {
      ...base,
      prefecture_id: locationDetail.id,
    }
  }

  return {
    ...base,
    prefecture_id: locationDetail.region?.id,
    facility_id: locationDetail.id,
  }
}
